import React from "react";
import { Navigate, Outlet } from "react-router";
import { useUser } from "../hooks/useAuth";
import Layout from "./Layout";


const AuthenticatedRoute = () => {
    const { data: user, isLoading } = useUser();

    if (isLoading) {
        return (
            <div className="min-h-screen bg-surface-base flex items-center justify-center">
                <p className="text-text-muted text-sm">Loading...</p>
            </div>
        );
    }

    return user ? (
        <Layout>
            <Outlet />
        </Layout>
    ) : (
        <Navigate to="/login" />
    );
};

export default AuthenticatedRoute;